import { useEffect } from 'react';
import { useSearchStore } from 'components/search/useSearchStore';

const useCmdK = () => {
    const { isOpen, setIsOpen } = useSearchStore();

    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            const cmdKey = event.metaKey || event.ctrlKey;
            const kKey = event.key === 'k';

            if (cmdKey && kKey) {
                event.preventDefault();
                if (!isOpen) {
                    setIsOpen(true);
                }
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen, setIsOpen]);
};

export { useCmdK };
